import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { IconProperties } from '../../../../ui/gzIcon/types';

export abstract class BaseIconHelper {
  public static getIconForProtectedEntity(protectedEntity: ProtectedEntity): IconProperties {
    throw new Error('Method not implemented.');
  }
}
